import { render, staticRenderFns } from "./PlanningMain.vue?vue&type=template&id=72270071&scoped=true"
import script from "./PlanningMain.vue?vue&type=script&lang=js"
export * from "./PlanningMain.vue?vue&type=script&lang=js"
import style0 from "./PlanningMain.vue?vue&type=style&index=0&id=72270071&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72270071",
  null
  
)

export default component.exports